import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/bulletins.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/cookies_banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/headers/global_header.tsx");
